"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchMetadata = void 0;
exports.searchMetadata = {
    /* this format is to match the current globalVarName of search-microview
     so searchMetadata can be used for adding script tag to the URL */
    name: 'search-microview',
    distFolderName: 'search',
};
//# sourceMappingURL=Metadata.js.map